<template>
	<div :class="{'container-fluid': storeLocation != 'project'}">
		<service-toolbar v-if="storeLocation == 'service'"></service-toolbar>
		<service-contract-toolbar v-else-if="storeLocation == 'serviceContract'"
			:hide-heading-widget="true">
		</service-contract-toolbar>
		<contact-toolbar v-else-if="storeLocation == 'contact'"></contact-toolbar>

		<collapsible-panel :always-open="true" panel-size="m">
			<template slot="panel">

				<h3 v-if="tags && tags.length > 0">Filter By Tag</h3>

				<p v-else>You can set up tags to better organize your files. <router-link to="/settings/file-tags">Add some tags now</router-link></p>

				<label v-for="tag in tags" class="tag-label">
					<input type="checkbox" :value="tag.friendly_slug" v-model="selectedTags" v-on:change="fetchFiles(true)">
					{{tag.name}}
				</label>
					
			</template>
			<template slot="main">

				<div class="d-flex flex-row justify-content-between">
					<h2>
						<template v-if="viewMode == 'files'">Files</template>
						<template v-else-if="viewMode == 'sharedFiles'">Shared Files Groups</template>
						<br>
						<template v-if="storeLocation == 'project' || storeLocation == 'service' || storeLocation == 'serviceContract'">
							<small>{{recordTypeLabel}} #{{$store[storeLocation][recordNumField]}}</small>
						</template>
						<small v-else>{{$store[storeLocation][recordNumField]}}</small>
					</h2>

					<div v-if="viewMode == 'files'">
						<button v-if="userCanWrite" class="btn btn-success mr-2" v-on:click="uploadFile">
							<i class="fa fa-upload"></i>
							Add a File...
						</button>

						<search-bar style="margin-right: 8px;position: relative;top: 2px"
							placeholder="Search files..."
							v-on:submit="searchFiles">
						</search-bar>

						<button v-if="selectedFiles.length > 0" class="btn btn-light mr-2" v-on:click="openTagModal">
							<i class="fa fa-tags mr-1"></i>
							Edit Tags...
						</button>

						<button class="btn btn-light" :disabled="selectedFiles.length == 0" v-on:click="openShareModal">
							<i class="fa fa-paper-plane mr-1"></i>
							<span v-if="selectedFiles.length > 1">Send Multiple Files...</span>
							<span v-else>Send File...</span>
						</button>

						<div class="text-right mt-2">
							<a href="#" v-on:click.prevent="setViewMode('sharedFiles')">View Previously Shared File Groups...</a>
						</div>
					</div>
					<div v-else>
						<i class="fa fa-times icon-button" v-on:click="setViewMode('files')"></i>
					</div>
				</div>

				<p v-if="viewMode == 'sharedFiles'">
					<a href="#" v-on:click.prevent="setViewMode('files')">
						<i class="fa fa-arrow-left"></i>
						Back to files
					</a>
				</p>

				<template v-if="viewMode == 'files'">
					<upload-field v-if="!readonly"
						style-type="box" 
						:icons="['fa-upload','fa-plus']"
						target="LibraryUpload/save"
						accept="documents/images"
						:readonly="readonly"
						:multiple="true"
						v-on:uploaded="fileDirectlyUploaded">
					</upload-field>

					<file-list-item v-for="(file,index) in mutatedFiles"
						:key="(fileKey * mutatedFiles.length) + index"
						:id="file.file_id"
						:tags="file.tags"
						:src="file.src"
						:thumb-src="file.thumbSrc"
						:label="file.UploadFile.original_filename"
						:size-kb="file.UploadFile.file_size_kb"
						:non-editable="!userCanWrite"
						:has-edit-button="true"
						:caption="file.caption"
						:uploaded-by="file.uploadedBy"
						:date-uploaded="file.created_at"
						:other-buttons="file.otherButtons"
						:selectable="true"
						v-on:selectChange="fileSelectChange($event,file)"
						v-on:editFile="editFile(file)"
						v-on:deleteFile="deleteFile(file)">

						<div v-if="file.UploadFile.sharing_on == 1" class="d-flex flex-row">
							<div style="flex-grow: 1">
								<field
									label="Sharing On"
									col-class="stacked"
									:value="file.shareLink">
								</field>
							</div>
							<div style="align-self: flex-end;margin-bottom: 0.3rem">
								<button class="btn btn-light" type="button" title="Copy link to clipboard" v-on:click="copyToClipboard(file.shareLink,true)">
									<i class="fa fa-copy"></i>
								</button>
							</div>
						</div>

					</file-list-item>

					<p v-if="mutatedFiles.length == 0">No files found</p>
				</template>
				<template v-else-if="viewMode == 'sharedFiles'">
					
					<table-list record-name="Shared File Group"
						:records="mutatedShareGroups"
						:fields="[
							{label: 'Description',key: 'description'},
							{label: 'Shared By',key: 'sharedBy'},
							{label: 'Number of Files',key: 'numFiles',align:'center'},
						]"
						:has-delete="true"
						delete-endpoint="FileShareGroup/delete"
						:other-buttons="sharedGroupOtherButtons"
						v-on:modelChange="fetchShareGroups"
						v-on:goToPortal="goToPortal"
						v-on:copyLinkToClipboard="copyLinkToClipboard">
					</table-list>

				</template>
			</template>
		</collapsible-panel>

		<job-file-upload-modal :visible="uploadModal.visible"
			:title="uploadModal.title"
			:record="uploadModal.record"
			:job-id="$store[storeLocation].id"
			:is-edit="uploadModal.isEdit"
			:store-location="storeLocation"
			:store-location-map="storeLocationMap"
		   :is-file="onlyFiles"
			v-on:closeModal="closeFileModal"
			v-on:modelChanged="refreshList">
		</job-file-upload-modal>

		<modal-dialog
			:modal-visible="deleteFileModal.visible"
			title="Delete File"
			confirm-button-text="Yes, Delete"
			button-class="btn-outline-danger"

			v-on:closeModal="deleteFileModal.visible = false"
			v-on:confirm="confirmDeleteFile">

			Delete this file?

		</modal-dialog>

		<share-group-modal
			:visible="isGroupShareModalVisible"
			:selected-records="selectedFiles"
			group-endpoint="FileShareGroup"
			:project-id="storeLocation == 'project' && 'id' in $store.project ? $store.project.id : false"
			:service-id="storeLocation == 'service' && 'id' in $store.service ? $store.service.id : false"
			:contact-id="storeLocation == 'contact' && 'id' in $store.contact ? $store.contact.id : false"
			v-on:closeModal="isGroupShareModalVisible = false">
		</share-group-modal>

		<modal-dialog
			:modal-visible="tagModal.visible"
			title="Edit File Tags"
			v-on:closeModal="tagModal.visible = false"
			v-on:confirm="saveFileTags">

			<div v-for="tag in tags" class="form-group row no-gutters mt-2 px-3">
				<label class="w-100">
					<input
						type="checkbox"
						class="mr-2"
						:indeterminate.prop="tagModal.indeterminateTagIds.includes(tag.id)"
						:checked="tagModal.determinateTagIds.includes(tag.id)"
						v-on:change="toggleFileTag(tag)">

					{{tag.name}}
				</label>
			</div>


		</modal-dialog>
	</div>


</template>
<script type="text/javascript">

import FileListItem from "@/components/FileListItem"
import UploadField from "@/components/UploadField"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import PanelMenu from "@/components/PanelMenu"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import SearchBar from "@/components/SearchBar"
import FormGroup from "@/components/FormGroup"
import ServiceToolbar from "./services/ServiceToolbar"
import ServiceContractToolbar from "./service_contract/ServiceContractToolbar"
import TableList from "@/components/TableList"
import ContactToolbar from "@/pages/contact/ContactToolbar";

import JobFileUploadModal from "@/components/super_components/JobFileUploadModal"
import ShareGroupModal from "@/components/super_components/ShareGroupModal";
import ServiceMixins from "@/mixins/ServiceMixins.js"
import InfoBox from "../../components/InfoBox.vue";

export default {
	name: "JobFiles",
	components: {
		InfoBox,
		FileListItem,
		UploadField,
		CollapsiblePanel,
		ModalDialog,
		Field,
		PanelMenu,
		SearchBar,
		FormGroup,
		ServiceToolbar,
		JobFileUploadModal,
		ServiceContractToolbar,
		TableList,
		ShareGroupModal,
		ContactToolbar
	},
	props: [
		"parentRecordSlug",
		"parentRecordSlugRouteParamKey",
		"parentResource",
		"storeLocation", //project, service, serviceContract, equipmentItem, contact, customerAsset
		"onlyFiles"      // append 'is_file=1' to fetches, assuming it exists on the model attached to storeLocation
	],
	mixins: [ServiceMixins],
	data() {
		return {
			localParentRecordSlug: null,
			fileKey: 0,
			viewMode: "files",
			files: [],
			tags: [],
			selectedTags: [],
			selectedFiles: [],
			sharedFileGroups: [],
			sharedFileGroupsFetched: false,
			apiRoot: window.apiRoot,
			uploadModal: {
				visible: false,
				record: null,
				title: "",
				isEdit: false
			},
			tagModal: {
				visible: false,
				determinateTagIds: [],
				indeterminateTagIds: []
			},
			deleteFileModal: {
				visible: false,
				file: null
			},
			isGroupShareModalVisible: false,
			storeLocationMap: {
				project: {
					apiResource: "JobFile",
					jobField: "job_id",
					tagFilterField: "is_for_projects",
					recordTypeLabel: "Project"
				},
				service: {
					apiResource: "ServiceFile",
					jobField: "service_id",
					tagFilterField: "is_for_services",
					recordTypeLabel: "Service"
				},
				serviceContract: {
					apiResource: "ServiceContractFile",
					jobField: "service_contract_id",
					tagFilterField: "is_for_service_contracts",
					recordTypeLabel: "Service Contract"
				},
				contact: {
					apiResource: "ContactFile",
					jobField: "contact_id",
					tagFilterField: "is_for_contacts",
					recordTypeLabel: "Contact"
				},
				equipmentItem: {
					apiResource: "EquipmentFile",
					jobField: "equipment_id",
					tagFilterField: "is_for_equipment",
					recordTypeLabel: "Equipment"
				},
				customerAsset: {
					apiResource: "CustomerAssetFile",
					jobField: "asset_id",
					tagFilterField: "is_for_customer_assets",
					recordTypeLabel: "Customer Asset"
				}
			}
		} 
	},
	watch: {
		parentRecordSlug() {
			this.setLocalParentRecordSlug()
			this.fetchData()
		},
		storeLocation() {
			if (this.parentResource && this.storeLocation)
				this.fetchFiles()
		},
		parentResource() {
			if (this.parentResource && this.storeLocation)
				this.fetchFiles()
		}
	},
	computed: {
		sharedGroupOtherButtons() {
			return [
				{
					click: "goToPortal",
					text: 'View',
					icon: 'fa-eye',
					title: 'View files in portal',
					class: 'btn-light'
				},
				{
					click: "copyLinkToClipboard",
					text: 'Copy Link',
					icon: 'fa-copy',
					title: 'Copy portal link to clipboard',
					class: 'btn-light'
				}
			]
		},
		mutatedShareGroups() {
			let vm = this

			return this.sharedFileGroups.map(group => {
				group.sharedBy = group.User.first_name+" "+group.User.last_name
				group.numFiles = group.UploadFile.length
				return group
			})
		},
		readonly() {
			if (this.$store[this.storeLocation].archived == 0)
				return false
			else
				return true
		},
		apiResource() {
			return this.storeLocationMap[this.storeLocation].apiResource
		},
		jobField() {
			return this.storeLocationMap[this.storeLocation].jobField
		},
		recordTypeLabel() {
			return this.storeLocationMap[this.storeLocation].recordTypeLabel
		},
		recordNumField() {
			if (this.storeLocation == 'project' || this.storeLocation == 'service')
				return 'job_num'
			else if (this.storeLocation == 'serviceContract')
				return 'contract_num'
			else if (this.storeLocation == 'contact')
				return 'name'
			else if (this.storeLocation == 'equipmentItem')
				return 'description'
			else if (this.storeLocation == 'customerAsset')
				return 'description'

			return false
		},
		userCanWrite() {
			let hasModulePermWrite = false
			if (this.storeLocation == 'project')
				hasModulePermWrite = this.hasModulePermWrite('Jobs')
			else if (this.storeLocation == 'service')
				hasModulePermWrite = this.hasModulePermWrite('Services')
			else if (this.storeLocation == 'serviceContract')
				hasModulePermWrite = this.hasModulePermWrite('Contracts')
			else if (this.storeLocation == 'contact')
				hasModulePermWrite = this.hasModulePermWrite('Contacts')
			else if (this.storeLocation == 'equipmentItem')
				hasModulePermWrite = this.hasModulePermWrite('Equipment')
			else if (this.storeLocation == 'customerAsset')
				hasModulePermWrite = this.hasModulePermWrite('Customer Assets')

			if (this.getUserRoleType() == "Admin" || hasModulePermWrite)
				return true
			else {
				//check role permissions

				if (this.$store.service && "JobPersonnelRole" in this.$store.service && this.$store.service.JobPersonnelRole) {
					let userHasRoleWritePerms = this.$store.service.JobPersonnelRole.find(role => role.user_id == this.$store.userDetails.id && role.write_perms == 1)

					if (userHasRoleWritePerms)
						return true
				}

				return false
			}
		},
		mutatedFiles() {
			let vm = this

			return this.files.map(file => {
				file.tags = file.FileTag.map(tag => {
					return tag.name
				})

				file.name = file.caption +' (' + file.UploadFile.original_filename + ')'

				file.uploadedBy = ""
				if ("UploadFile" in file && file.UploadFile) {
					file.uploadedBy = file.UploadFile.UpdatedBy.first_name + " " + file.UploadFile.UpdatedBy.last_name

					if (file.UploadFile.sharing_on == 1) 
						file.shareLink = window.apiRoot+"portal/sharing/"+file.UploadFile.slug
				}

				file.src = vm.apiRoot + 'resources/files/'+vm.$store.sessionToken+'/'+file.UploadFile.filename

				file.thumbSrc = file.src
				if (file.UploadFile.thumb_filename != "")
					file.thumbSrc = vm.apiRoot + 'resources/images/'+vm.$store.sessionToken+'/'+file.UploadFile.thumb_filename

				file.otherButtons = []

				return file
			})
		},
		tagsOptions() {
			return this.optionify(this.tags,"name")
		}
	},
	methods: {
		setLocalParentRecordSlug() {
			if (this.parentRecordSlug)
				this.localParentRecordSlug = this.parentRecordSlug
			else if (this.parentRecordSlugRouteParamKey && this.parentRecordSlugRouteParamKey in this.$route.params)
				this.localParentRecordSlug = this.$route.params[this.parentRecordSlugRouteParamKey]
		},
		saveFileTags() {
			let vm = this

			const records = this.selectedFiles.map(file => {

				let fileTagIds = []
				const fullFile = this.mutatedFiles.find(mf => file.id == mf.file_id)
				if ('FileTag' in fullFile && fullFile.FileTag)
					fileTagIds = fullFile.FileTag.map(tag => tag.id)

				const keepTags = fileTagIds.filter(tag => this.tagModal.indeterminateTagIds.includes(tag))

				return {
					id: fullFile.id,
					FileTag: this.tagModal.determinateTagIds.concat(keepTags)
				}
			})

			const promises = records.map(record => {
				return this.postData(this.apiResource + "/save", record)
			})

			Promise.all(promises).then(responses => {
				vm.tagModal.visible = false
				vm.fetchFiles()
			})
		},
		toggleFileTag(tag) {

			// toggle whether the tag is selected
			const dTagIndex = this.tagModal.determinateTagIds.findIndex(tagId => tagId == tag.id)
			if (dTagIndex != -1)
				this.tagModal.determinateTagIds.splice(dTagIndex, 1)
			else
				this.tagModal.determinateTagIds.push(tag.id)

			// turn "indeterminate" off if its turned on
			const ndTagIndex = this.tagModal.indeterminateTagIds.findIndex(tagId => tagId == tag.id)
			if (ndTagIndex != -1)
				this.tagModal.indeterminateTagIds.splice(ndTagIndex, 1)
		},
		openTagModal() {

			const filesTagIds = this.selectedFiles.map(file => {
				const fullFile = this.mutatedFiles.find(mf => file.id == mf.file_id)
				if (fullFile && 'FileTag' in fullFile && fullFile.FileTag)
					return fullFile.FileTag.map(tag => tag.id)
				return []
			})

			this.tagModal.determinateTagIds = this.tags.filter(tag => {
				return filesTagIds.every(tagList => tagList.includes(tag.id))
			}).map(tag => tag.id)

			this.tagModal.indeterminateTagIds = this.tags.filter(tag => {
				return filesTagIds.some(tagList => tagList.includes(tag.id)) && !this.tagModal.determinateTagIds.includes(tag.id)
			}).map(tag => tag.id)

			this.tagModal.visible = true
		},
		closeFileModal() {
			this.uploadModal.visible = false
			this.fileKey += 1
		},
		refreshList() {
			this.fetchFiles(true)
			this.fileKey += 1
		},
		setViewMode(mode) {
			if (mode == 'sharedFiles')
				this.fetchShareGroups()

			this.viewMode = mode
		},
		copyLinkToClipboard(record) {
			this.copyToClipboard(this.apiRoot+"portal/sharing/package/"+record.slug,true)
		},
		goToPortal(record) {
			window.open(this.apiRoot+"portal/sharing/package/"+record.slug)
		},
		resetUploadModal() {
			this.uploadModal = {
				filename: false,
				editing: false,
				visible: false,
				id: null,
				caption: "",
				tags: [],
				fileId: null,
				title: "",
				sharing_on: 0,
				shareLink: "",
				fileObj: null,
				record: {}
			}
		},
		fileSelectChange(selected,file) {
			if (selected)
				this.selectedFiles.push(file.UploadFile)
			else {
				let index = this.selectedFiles.findIndex(f => f.id == file.UploadFile.id)
				this.selectedFiles.splice(index,1)
			}
		},
		cancelUpload() {
			this.uploadModal.visible = false

			if (this.uploadModal.fileId && !this.uploadModal.id) {
				//we have to delete the file quietly in the background so we don't clutter anything
				this.postData("LibraryUpload/delete",{id: this.uploadModal.fileId})
			}

			this.resetUploadModal()
		},
		uploadFile() {
			this.uploadModal.title = "Upload a New File"

			this.resetUploadModal()
			this.uploadModal.visible = true
		},
		editFile(file) 
		{
			this.uploadModal.visible = true
			this.uploadModal.record = file
			this.uploadModal.isEdit = true
			this.uploadModal.title = "Edit file details"
		},
		openShareModal() {
			this.isGroupShareModalVisible = true
		},
		deleteFile(file) {
			this.deleteFileModal.visible = true
			this.deleteFileModal.file = file
		},
		confirmDeleteFile() {
			let vm = this

			let promises = [
				this.postData(this.apiResource+"/delete",{id: this.deleteFileModal.file.id}),
				this.postData("LibraryUpload/delete",{id: this.deleteFileModal.file.UploadFile.id})
			]

			Promise.all(promises).then(responses => {
				if (responses[0].success && responses[1].success) {
					vm.fetchFiles(false)
					vm.alertSuccess("File deleted")
				}
				else
					vm.alertFail("There was a problem deleting the file")

				vm.deleteFileModal.visible = false
				vm.deleteFileModal.file = null
			})
		},
		fileDirectlyUploaded(response) {
			let vm = this

			let payload = {
				file_id: response.data.id
			}

			if (this.onlyFiles)
				payload.is_file = 1

			payload[this.jobField] = this.$store[this.storeLocation].id

			this.postData(this.apiResource+"/save",payload,true).then(response => {
				if (response.success)
					vm.fetchFiles()
			})
		},
		/*saveFileDetails() {
			let vm = this

			let payload = {}
			let saveMessage = ""

			let filePayload = {
				id: this.uploadModal.fileId,
				sharing_on: this.uploadModal.sharing_on
			}
			
			if (this.uploadModal.editing) {
				payload = {
					id: this.uploadModal.id,
					caption: this.uploadModal.caption,
					//file_share_link: this.uploadModal.file_share_link,
					JobFileTag: this.uploadModal.tags
				}

				saveMessage = "File details saved"
			}
			else if (this.uploadModal.fileId) {

				payload = {
					file_id: this.uploadModal.fileId,
					caption: this.uploadModal.caption,
					//file_share_link: this.uploadModal.file_share_link,
					JobFileTag: this.uploadModal.tags
				}

				payload[this.jobField] = this.$store[this.storeLocation].id

				saveMessage = "File uploaded to "+this.storeLocation+"!"
			}
			else
				vm.alertFail("You need to upload an image!")

			if (Object.keys(payload).length > 0) {

				let promises = [
					this.postData(this.apiResource+"/save",payload,true),
					this.postData("UploadFile/update",filePayload)
				]

				Promise.all(promises).then(responses => {
					if (responses[0].success) {
						vm.alertSaved(saveMessage)
						vm.fetchFiles()
						vm.uploadModal.visible = false

						vm.resetUploadModal()
					}
				})
			}
		},
		*/
		searchFiles(searchTerms) {
			let vm = this

			let params = {
				include: [
					"FileTag",
					{	
						model: "UploadFile",
						include: [{model:"User",fields: ["id","slug","first_name","last_name"]}]
					}
				]
			}

			params.filters = [
				[this.jobField,this.$store[this.storeLocation].id],
				["caption",searchTerms,"and","like"]
			]

			if (this.onlyFiles)
				params.filters.push(['is_file', 1])

			params.filters = params.filters.concat([
				[this.jobField,this.$store[this.storeLocation].id,"or"],
				["UploadFile.original_filename",searchTerms,"and","like"]
			])

			if (this.onlyFiles)
				params.filters.push(['is_file', 1])

			this.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON(vm.apiResource+"/get",params,true).then(response => {
					
					vm.spinner(false)

					if (response.success) 
						vm.files = response.data

					resolve(response)
				})
			})
		},
		fetchShareGroups() {
			let vm = this

			this.sharedFileGroupsFetched = true

			let params = {
				include: [
					{
						model: "User",
						fields: ["id","slug","first_name","last_name"]
					},
					"UploadFile"
				],
				filters: [
					[this.jobField,this.$store[this.storeLocation].id]
				]
			}
			this.spinner(true)
			this.getJSON("FileShareGroup/get",params).then(response => {
				vm.spinner(false)
				if (response.success) 
					vm.sharedFileGroups = response.data
			})
		},
		fetchFiles(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {
				include: [
					"FileTag",
					{	
						model: "UploadFile",
						include: [{model:"User",fields: ["id","slug","first_name","last_name"]}]
					}
				],
				filters: [
					[this.jobField,this.$store[this.storeLocation].id]
				]
			}

			if (this.onlyFiles)
				params.filters.push(['is_file', 1])

			if (this.selectedTags.length > 0) {
				this.selectedTags.forEach(tagFriendlySlug => {
					params.filters.push(["FileTag.friendly_slug",tagFriendlySlug])
				})
			}

			return new Promise((resolve,reject) => {
				if (!this.$store[this.storeLocation] || !("id" in this.$store[this.storeLocation])) {
					console.log(this.parentResource + "/find/" + this.localParentRecordSlug)
					this.getJSON(this.parentResource + "/find/" + this.localParentRecordSlug).then(response => {
						if (response.success) {
							params.filters[0] = [this.jobField,response.data.id]

							vm.$store[vm.storeLocation] = response.data

							vm.getJSON(vm.apiResource+"/get",params,true).then(response => {
						
								if (spinner)
									vm.spinner(false)

								if (response.success) 
									vm.files = response.data

								resolve(response)
							})		
						}
						else
							resolve({success: false})
					})
				}
				else {	
					vm.getJSON(vm.apiResource+"/get",params,true).then(response => {
						
						if (spinner)
							vm.spinner(false)

						if (response.success) 
							vm.files = response.data

						resolve(response)
					})		
				}
			})
		},
		fetchData() {
			let vm  = this

			let field = this.storeLocationMap[this.storeLocation].tagFilterField

			let promises = [
				this.getJSON("FileTag/get",{filters:[[field,1]]})
			]

			if (this.storeLocation == 'service')
				promises.push(this.setServiceIfNotSet())
			else if (this.storeLocation)

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

				vm.tags = responses[0].data

				console.log(vm.storeLocation, vm.jobField)
				if (vm.storeLocation && vm.jobField && vm.parentResource)
					vm.fetchFiles(false)
			})
		}
	},
	created() {
		this.setLocalParentRecordSlug()

		this.fetchData()
	}
}
</script>

<style type="text/css" scoped>
	label.tag-label {
		display: block;
	}
</style>